import { DateTime } from 'luxon';

export function createNewCandleTimeStamp(
  nextCandleTimeStampRef,
  millisBetweenCandles,
  timeUnit,
  candleDuration
) {
  if (timeUnit === 'MINUTES') {
    const tempTimeStamp = nextCandleTimeStampRef.current;
    const newNextTimeStamp =
      nextCandleTimeStampRef.current + millisBetweenCandles;
    nextCandleTimeStampRef.current = newNextTimeStamp;
    return tempTimeStamp;
  }
  if (timeUnit === 'DAYS') {
    const tempTimeStamp = nextCandleTimeStampRef.current;
    const newNextTimeStamp = DateTime.fromMillis(nextCandleTimeStampRef.current)
      .setZone('America/New_York')
      .plus({
        days: candleDuration,
      })
      .toMillis();
    nextCandleTimeStampRef.current = newNextTimeStamp;
    return tempTimeStamp;
  }
  if (timeUnit === 'WEEKS') {
    const tempTimeStamp = nextCandleTimeStampRef.current;
    const newNextTimeStamp = DateTime.fromMillis(nextCandleTimeStampRef.current)
      .setZone('America/New_York')
      .plus({
        weeks: candleDuration,
      })
      .toMillis();
    nextCandleTimeStampRef.current = newNextTimeStamp;
    return tempTimeStamp;
  }
  if (timeUnit === 'MONTHS') {
    const tempTimeStamp = nextCandleTimeStampRef.current;
    const newNextTimeStamp = DateTime.fromMillis(nextCandleTimeStampRef.current)
      .setZone('America/New_York')
      .plus({
        months: candleDuration,
      })
      .toMillis();
    nextCandleTimeStampRef.current = newNextTimeStamp;
    return tempTimeStamp;
  }
  if (timeUnit === 'YEARS') {
    const tempTimeStamp = nextCandleTimeStampRef.current;
    const newNextTimeStamp = DateTime.fromMillis(nextCandleTimeStampRef.current)
      .setZone('America/New_York')
      .plus({
        years: candleDuration,
      })
      .toMillis();
    nextCandleTimeStampRef.current = newNextTimeStamp;
    return tempTimeStamp;
  }
}
